<template>
  <div class="el-card-dashboard">
    <el-row :gutter="24">
      <el-col :span="24">
        <el-card>
          <div slot="header" class="card-div-header">
            <span class="span-title">待办任务</span>
          </div>
          <div class="main-body-table">
            <el-table
              :data="noticeFemsTable"
               @row-dblclick="rowDblclick"
              style="width: 100%;height:200px;overflow: auto">
                <el-table-column width="250"
                  prop="title"
                  label="标题" show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="message"
                  label="内容" show-overflow-tooltip>
                </el-table-column>
                <el-table-column :label="$t('c.table.operation')" width="120" align="center">
                  <template slot-scope="scope">
                    <el-button v-show="manager&&scope.row.status !== '1'" type="danger" size="small" @click="jumpPage(scope.row)">处理</el-button>
                    <el-button type="danger" v-show="!manager&&scope.row.status !== '1'" size="small" @click="openFemsNoticeDialog(ACTION.READ, scope.row, scope.$index)">确认已读</el-button>
                  </template>
                </el-table-column>
            </el-table>
            <!--工具条-->
            <el-pagination
              class="main-body-table-page"
              layout="total, prev, pager, next, jumper"
              @current-change="handleCurrentChange2"
              :current-page="page2.current"
              :page-size="page2.size"
              :total="page2.total">
            </el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <div v-show="showOrgInfo">
      <el-input
        v-model="orgNameSearch"
        size="mini"
        placeholder="机构名称查询"
        style="width:17%; float:right; margin-top:20px;margin-right:30px"
        @change="findOrgList()"
          />
    </div>
    <div id="test" class="fems-home-search" v-show="showOrgInfo" style="font-size:13px;">
        <div
            class="goods"
            v-for = "goods in goodsList"
            :key = "goods.id"
         >
        <div class="goodsTitle">{{ goods.title }}:</div>
        <ul class="type-list">
            <li v-for = "(type, index) in goods.typeList">
            <el-link  :underline="false" @click = "addFilterHandle(type,goods.id)">{{ type.value }}</el-link>
            </li>
        </ul>
        </div>
        <div
      class="choose-type"
    >


      <div class="fems-home-search1">已选条件:</div>
      <div style="height: 50px;overflow-y: auto;">
          <el-tag v-if="!selectedGoods.length || selectedGoods.length === 0" style="margin-top: 10px;margin-left:30px;" size="medium">暂无筛选条件</el-tag></span>
          <el-tag style="margin-top: 10px;margin-left:15px;" v-for="goods in selectedGoods" :key="goods.key" closable size="medium" @close="deleteFilterGoods(goods)">{{ goods.value }}</el-tag>
        </div>
      </div>


      <div class="main-body-table">


      <!--查询列表-->
      <el-table :data="tableData" style="width: 100%;"  @row-dblclick="orgRowDblclick">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="name" label="机构名称" width="230" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="chiefName" label="首席代表" width="140" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="renewalDate" label="设立时间" width="100" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="address" label="地点" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="headquartersName" label="联络人" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="telephone" label="联系电话" width="110" align="center" show-overflow-tooltip></el-table-column>
      </el-table>
      <!--工具条-->
      <el-pagination
        class="main-body-table-page"
        layout="total, prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total">
      </el-pagination>
    </div>
    </div>


    <my-audit-log v-if="showAuditLogDialog"
      :isVisible.sync="showAuditLogDialog"
    >
    </my-audit-log>
    <comp-notice v-if="showNoticeDialog"
      :actionOfParent="currentAction"
      :currentTableRow="currentTableRow"
      :detailDialogVisible.sync="showNoticeDialog"
    >
    </comp-notice>
    <comp-fems-notice
      v-if="showFemsNoticeDialog"
      :actionOfParent="currentFemsAction"
      :currentTableRow="currentFemsTableRow"
      :detailDialogVisible.sync="showFemsNoticeDialog"
    >
  </comp-fems-notice>
  <comp-org-info v-if="showOrgInfoDialog"
      :detailDialogVisible.sync="showOrgInfoDialog"
      :currentOrgTableRow = "currentOrgTableRow"
  >
  </comp-org-info>
  </div>
</template>

<script>
import { selectRecently, selectMyNotice, updateNoticeForRead, getResidentOfficeTypes, selectOrgList, selectResidentOfficeForIndexPage} from '../api/DashBoard'
import { selectMyFemsNotice,updateFemsNoticeForRead } from '@/views/console/api/notice/FemsNotice'
import MyAuditLog from '@/views/base/comp/MyAuditLog.vue'
import CompNotice from '@/views/yourbiz/comp/sys/CompNotice.vue'
import CompFemsNotice from '@/views/yourbiz/comp/notice/CompMyFemsNotice'
import CompOrgInfo from '@/views/yourbiz/comp/sys/CompOrgInfo.vue'
export default {
  components: {
    MyAuditLog,
    CompNotice,
    CompFemsNotice,
    CompOrgInfo
  },
  data() {
    return {
      // 操作类型常量
      ACTION: {
        READ: { value: 4, name: this.$t('c.table.view') }
      },
      // 当前操作类型, ACTION.READ
      currentAction: {},

      // 我的审计日志列表
      auditRecentlyTable: [],
      // 是否显示我的审计日志对话框
      showAuditLogDialog: false,
      // 通知列表
      noticeTable: [],
      // 是否显示通知对话框
      showNoticeDialog: false,
      // 是否显示通知对话框
      showFemsNoticeDialog: false,

      // 当前主表行记录
      currentTableRow: {},
      // 通知列表
      noticeFemsTable: [],
      manager:false,



      // 当前行记录
      currentFemsTableRow: {},
      // 当前操作类型, ACTION.READ
      currentFemsAction: {},
      filterObj:[],
      showFiltergoods:true, //展示选择条件
      showFilterInfo:true,//筛选条件信息
      orgNameSearch:'',//机构名称查询
      goodsList: [
      {
        title: '机构类型                ',
        typeList: [{key: 'all', value: '全部',goodsId: '1'}],
        id: '1',
      },
      {
        title: '部内片区划分 ',
        typeList: [{key: 'all', value: '全部',goodsId: '2'}],
        id: '2',
      },
      {
        title: '驻在城市                ',
        typeList: [{key: 'all', value: '全部', goodsId: '3'}, {key: 'Beijing', value: '北京', goodsId: '3'}, {key: 'Shanghai', value: '上海', goodsId: '3'},  {key: 'Guangzhou', value: '广州', goodsId: '3'},  {key: 'Chengdu', value: '成都', goodsId: '3'},  {key: 'Kunming', value: '昆明', goodsId: '3'},  {key: 'Xian', value: '西安', goodsId: '3'},  {key: 'Shenyang', value: '沈阳', goodsId: '3'}],
        id: '3',
      }
      // ,{
      //   title: '存续情况',
      //   typeList: ['全部', '正常运营', '关闭', '筹建中' ,'其他'],
      //   id: 4,
      // }
    ],
      // 查询列表数据--机构信息
      tableData: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      page2: {
        current: 1,
        size: 10,
        total: 0
      },
      showOrgInfo: true,
      selectedGoods: [],
      categoryList: [],
      areaList: [],//国家片区查询

      provinceList: [],
      // 是否显示机构对话框
      showOrgInfoDialog: false,
      // 机构列表行
      currentOrgTableRow: {},
    }
  },
  mounted() {
  this.goodsList[0].typeList = this.utils.orgCategories;
  this.goodsList[1].typeList = this.utils.countryArea;
  // this.goodsList[2].typeList = this.utils.province;

    // 业务需要 - 查询登录用户可操作的机构权限
    this.getResidentOfficeTypes();
    this.getFemsNoticeList();
    var manager = sessionStorage.getItem('manager');
    if(manager && manager === 'true') {
      this.manager = true;
      //this.getFemsNoticeList();
      this.showOrgInfo = true;
      this.goodsList.forEach(item => this.$set(item, 'index', 0));
      this.findOrgList();
    } else {
      // 默认查询
      //this.getList()
      this.manager = false
      this.showOrgInfo = false;
    }

  },
  methods: {
    //查询点击方法
    /* addFilterHandle (typeIndex, goods, type, goodsIndex) {
          if(type === '全部') {        //如果标签等于全部,则返回结果
            return;
          }
          this.showFilterGoods = true;   //已选条件内容显示
          this.showFilterInfo = false;
          goods.index = typeIndex;     //goodsList的索引值等于typeIndex
          this.$set(this.filterObj, goodsIndex, type);  //用来更新数组或者对象  需要更新的数组或对象,索引值,更新的内容
    }, */
    //添加机构查询条件
    addFilterHandle(goodsType, goodsId) {
      if(goodsType.key === 'all') {        //如果标签等于全部,则返回结果
        goodsType.goodsId = goodsId;
        if(goodsType.goodsId === '1') {
          this.categoryList = [];
          this.categoryList.push(goodsType);
        } else if(goodsType.goodsId === '2') {
          this.areaList = [];
          this.areaList.push(goodsType);
        } else if(goodsType.goodsId === '3') {
          this.provinceList = [];
          this.provinceList.push(goodsType);
        }
        var newGoodsList = [];
        for (let i = 0; i < this.selectedGoods.length; i++) {
          if (this.selectedGoods[i].goodsId !== goodsId) {
            newGoodsList.push(this.selectedGoods[i]);
          }
        }
        this.selectedGoods = newGoodsList;
        this.findOrgList();
        return;
      }
      let exists = false;
      for (let i = 0; i < this.selectedGoods.length; i++) {
        if (this.selectedGoods[i].key === goodsType.key) {
          exists = true;
          break;
        }
      }
      if (!exists) {
        goodsType.goodsId = goodsId;
        this.selectedGoods.push(goodsType);  //TODO 这报错了
        if(goodsId === '1') {
          this.categoryList.push(goodsType);
        } else if(goodsId === '2') {
          this.areaList.push(goodsType);
        } else if(goodsId === '3') {
          this.provinceList.push(goodsType);
        }
      }
      this.findOrgList();
    },
    /* deleteFilterGoods (goodsKey) {
        alert("删除")
        this.$delete(this.filterObj, goodsKey);  //删除
        this.goodsList[goodsKey].index = 0;   //点击删除之后  选中状态为全部 索引为0
        this.changeShowFilter();  //目的是全部删除之后 暂时没有过滤条件 存在
    },*/
    deleteFilterGoods(goodsType) {
      for (let i = 0; i < this.selectedGoods.length; i++) {
        if (this.selectedGoods[i].key === goodsType.key) {
          this.selectedGoods.splice(i, 1);
        }
      }

      if(goodsType.goodsId === '1') {
        for (let i = 0; i < this.categoryList.length; i++) {
          if (this.categoryList[i].key === goodsType.key) {
            this.categoryList.splice(i, 1);
          }
        }
      } else if(goodsType.goodsId === '2') {
        for (let i = 0; i < this.areaList.length; i++) {
          if (this.areaList[i].key === goodsType.key) {
            this.areaList.splice(i, 1);
          }
        }
      } else if(goodsType.goodsId === '3') {
        for (let i = 0; i < this.provinceList.length; i++) {
          if (this.provinceList[i].key === goodsType.key) {
            this.provinceList.splice(i, 1);
          }
        }
      }
      this.findOrgList();
    },
    changeShowFilter () {
      const filterObjStr = JSON.stringify(this.filterObj);
      this.showFilterGoods = filterObjStr !== '{}';   //filterObjStr空了 showFilterGoods变为false
    },
    // 查询
    getList() {
      selectRecently().then(result => {
        this.auditRecentlyTable = result.data.records
      })
      // selectMyNotice().then(result => {
      // //  this.noticeTable = result.data
      // })
      var params = {current: this.page2.current, size: this.page2.size};
      selectMyNotice(params).then(result => {
        let { data } = result;
        this.page2.total = result.total;
        this.noticeFemsTable = data

      });
    },
    // 业务需要 - 查询登录用户可操作的机构权限
    getResidentOfficeTypes() {
      getResidentOfficeTypes().then(result => {
        var dynamicResidentOfficeTypes = [];
        // 循环迭代判断登录用户拥有什么机构类型管理权
        if(result.code == 20000 && result.data) {
          var residentOfficeTypes = this.utils.orgCategories;
          for (var i = 0; i < result.data.length; i++) {
            var residentOfficeType = result.data[i].residentOfficeType;
            for (var y = 0; y < residentOfficeTypes.length; y++) {
              if(residentOfficeTypes[y].key == residentOfficeType) { // 和前台字典进行匹配
                dynamicResidentOfficeTypes.push(residentOfficeTypes[y]);
              }
            }
          }
          let str = JSON.stringify(dynamicResidentOfficeTypes);
          sessionStorage.setItem('dynamicResidentOfficeTypes', str);
        }
      })
    },
    /**
     * 打开任务对话框
     * @param action ACTION.ADD/ACTION.VIEW/ACTION.EDIT
     * @param row 行记录对象，新增时为空
     * @param indexOfRow 行索引号，新增时为空
     */
    openDialog(action, row, indexOfRow) {
      this.currentTableRow = row
      this.currentAction = action
      // 已经加载外键列表数据，可以直接弹出对话框
      this.showNoticeDialog = true

      //标记已读notice
      // if (row.status !== '1' && row.id) {
      //   this.$set(row, 'status', '1')
      //   updateNoticeForRead({ noticeId: row.id }).then(result => { })
      // }
    },
    /**
     * 待办任务表格行双击事件打开查看对话框
     * @param row 双击的行记录对象
     * @param event 鼠标事件
     * @param column 双击的列对象
     */
    rowDblclick(row, event, column) {
      this.openDialog(this.ACTION.READ, row)
    },
    // 查询fems消息通知
    getFemsNoticeList() {
      var manager = sessionStorage.getItem('manager');
      var params = {current: this.page2.current, size: this.page2.size,manager:manager};
      selectResidentOfficeForIndexPage(params).then(result => {
        let { data } = result;
        this.page2.total = result.total;
        this.noticeFemsTable = data

      });
    },
    jumpPage(row) {
      var tabNum = row.tabNum;
      var residentOfficeId = row.residentOfficeId;
      this.$router.push({path: row.path,query:{activeName:tabNum ,residentOfficeId:residentOfficeId}});
    },
    /**
     * 打开femsNotice对话框
     * @param action ACTION.ADD/ACTION.VIEW/ACTION.EDIT
     * @param row 行记录对象，新增时为空
     * @param indexOfRow 行索引号，新增时为空
     */
    openFemsNoticeDialog(action, row, indexOfRow) {
      this.currentFemsTableRow = row
      this.currentFemsAction = action
      // 已经加载外键列表数据，可以直接弹出对话框
      this.showFemsNoticeDialog = true
      if (row.status !== '1') {
        this.$set(row, 'status', '1')
        updateFemsNoticeForRead({ noticeId: row.id }).then(result => { })
      }
    },

    /**
    * 机构
    */
    handleCurrentChange(val) {
      this.page.current = val;
      this.findOrgList();
    },
    handleCurrentChange2(val) {
      this.page2.current = val;
      this.getFemsNoticeList();
    },
    //条件展示颜色
    changeLinkType(goods, index) {
      if(goods.id === '1') {
        if(index % 3 === 0) {
          return 'warning';
        } else if(index % 3 === 1) {
          return 'success';
        } else if(index % 3 === 2) {
          return 'danger';
        }
      } else if(goods.id === '2') {
        if(index % 3 === 0) {
          return 'danger';
        } else if(index % 3 === 1) {
          return 'warning';
        } else if(index % 3 === 2) {
          return 'success';
        }
      } else if(goods.id === '3') {
        if(index % 3 === 0) {
          return 'success';
        } else if(index % 3 === 1) {
          return 'danger';
        } else if(index % 3 === 2) {
          return 'warning';
        }
      }
    },
    getChangeApplicationList() {
      this.changeApplicationFilters.current = this.changePage.current //当前页数
      this.changeApplicationFilters.size = this.changePage.size
      getChangeApplicationSelectPage(this.changeApplicationFilters).then(result => {
        if(result.code == 20000 && result.data) {
          result.data.forEach(row => {
            row.approvalStatusTabName = dateUtil.findDictItemValueByItemCode(row.approvalStatus, this.utils.approvalStatus);
            if (this.utils.culturalCenter == row.residentOfficeType) {
              row.typeTabName = dateUtil.findDictItemValueByItemCode(row.type, this.utils.changeCulturalCenterType);
            } else {
              row.typeTabName = dateUtil.findDictItemValueByItemCode(row.type, this.utils.changeType);
            }
          });
          this.changePage.total = result.total;
          this.changeApplicationTableData = result.data;
        }
      }).catch(() => {
        return this.$message.error(`数据查询异常`);
      });
    },
    //机构查询
    findOrgList() {
      var params = {current: this.page.current, size: this.page.size, from: 'dashboard'};
      if(this.categoryList.length > 0) {
        var categoryStr = '';
        for(var i = 0;i < this.categoryList.length;i++) {
          if(this.categoryList[i].key !== 'all') {
            categoryStr += this.categoryList[i].key + ',';
          }
        }
        params.categoryStr = categoryStr;
      }
      if(this.areaList.length > 0) {
        //var continentStr = '';
        //var countrys = this.utils.country;
        // for(var i = 0;i < this.areaList.length;i++) {
        //   if(this.areaList[i].key !== 'all') {
        //     for(var j = 0;j < countrys.length;j++) {
        //       if(countrys[j].continent === this.areaList[i].key) {
        //         continentStr += countrys[j].alphabetCode + ',';
        //       }
        //     }
        //   }
        // }
        var areaStr = '';
        for(var i = 0;i < this.areaList.length;i++) {
          if(this.areaList[i].key !== 'all') {
            areaStr += this.areaList[i].key + ',';
          }
        }
        params.areaStr = areaStr;
      }
      if(this.provinceList.length > 0) {
        var provinceStr = '';
        for(var i = 0;i < this.provinceList.length;i++) {
          if(this.provinceList[i].key !== 'all') {
            provinceStr += this.provinceList[i].value + ',';
          }
        }
        params.provinceStr = provinceStr;
      }
      if(this.orgNameSearch) {
        params.name = this.orgNameSearch;
      }

      selectOrgList(params).then(result => {
        this.page.total = result.total;
        this.tableData = result.data;

      });
    },
    /**
     * 机构信息双击事件打开查看机构详情 20211123
     * @param row 双击的行记录对象
     * @param event 鼠标事件
     * @param column 双击的列对象
     */
    orgRowDblclick(row, event, column) {
        this.showOrgInfoDialog = true;
        this.currentOrgTableRow = row
      //this.openDialog(this.ACTION.READ, row)
    }
  }
}
</script>

<style lang="scss">
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-card-dashboard {
  .el-card__body {
    padding-top: 0px;
  }
  .card-div-header {
    display:flex;
    .span-title{
        flex:1;
    }
    .span-right {
      padding-left: 8px;
      cursor: pointer;
    }
  }
  .card-table {
    border-width: 0px;
    margin-top: 0px;
    padding: 0px;
  }
}
.goodsTitle {
  width: 170px
}
</style>
